import { FC, useState } from 'react';
import * as Yup from 'yup';
import { withStyles, Card, TextField, Box, CircleButton } from 'vopay';
import { Title, Button } from 'UI';
import { renderDefaultFormElement } from '@/components/Form/utils';
import { useTranslation } from 'react-i18next';
import styles from './AddEmailDialog.module.scss';

const cn = withStyles(styles);

type AddEmailDialogProps = {
  emails: string[];
  onClose: () => void;
  onAdd: (val: string) => void;
};

const AddEmailDialog: FC<AddEmailDialogProps> = ({ emails = [], onClose, onAdd }) => {
  const [email, setEmail] = useState('');
  const { t } = useTranslation('translations', {
    keyPrefix: 'Elinx.Form.ELinxSettings.AdditionalRecipientEmails.EmailDialog',
  });
  const emailValidationSchema = Yup.string().email().required();
  const isEmailValid = emailValidationSchema.isValidSync(email);
  const isEmailUnique = !emails.includes(email);

  function handleAddEmail() {
    if (!isEmailValid || !isEmailUnique) return;
    onAdd(email);
  }

  return (
    <Card className={cn('addEmailDialog')}>
      <Box jc="sb" ai="center">
        <Title level="3">{t('title', { defaultValue: 'Additional Email Address' })}</Title>
        <CircleButton icon="close" size="large" onClick={onClose} />
      </Box>

      {renderDefaultFormElement({
        fieldName: 'email',
        label: t('label', { defaultValue: 'Email Address' }),
        inputState: 'required',
        tooltip: null,
        template: (
          <TextField
            name="email"
            variant="outlineShadow"
            placeholder={t('placeholder', { defaultValue: 'Enter' })}
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            onKeyDown={(e) => {
              if (e.key === 'Enter') {
                handleAddEmail();
              }
            }}
          />
        ),
      })}

      <div className={cn('cta')}>
        <Button disabled={!isEmailValid || !isEmailUnique} colorScheme="primary" onClick={handleAddEmail}>
          {t('button', { defaultValue: 'Add Email Address' })}
        </Button>
      </div>
    </Card>
  );
};

export default AddEmailDialog;
